import { createAction, props } from '@ngrx/store';

const DISTRICT = 'DISTRICT';

export const getAllDistrict = createAction(`[${DISTRICT}] Get All Districts`);
export const getAllDistrictSuccess = createAction(`[${DISTRICT}] Get All Districts Success`, props<{ allDistricts: any }>());
export const getAllDistrictFailure = createAction(`[${DISTRICT}] Get All Districts Failure`, props<{ errorMessage: string }>());

export const updateCurrentDistrict = createAction(`[${DISTRICT}] Update Current District`, props<{ currentDistrictIds: number[] }>());
